import styled from 'styled-components';
import { SEARCH_IFRAME_OFFSET_TOP } from '../../constants';
export const StyledSearchContainer = styled.div.withConfig({
  displayName: "StyledSearchContainer",
  componentId: "sc-1hf0beb-0"
})(["position:relative;margin-top:", "px !important;max-width:100%;width:100%;"], SEARCH_IFRAME_OFFSET_TOP);